import React from "react";
import { Modal } from "react-bootstrap";
import PassCard from "./passCard";
import { formatEventDate } from "../../utils/formatEventDate";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";

const to12Hour = (time) => {
  if (!time || time === "00:00" || time === "null" || time === "undefined") {
    return "TBD";
  }

  const [hour, minute] = time.split(":");
  const dt = new Date();
  dt.setHours(hour, minute);

  if (isNaN(dt.getTime())) return "TBD";

  return dt.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const PassDetailsModal = ({
  show,
  onHide,
  ticket,
  tickets = [],
  event,
  onDownload,
}) => {
  const passList = tickets.length ? tickets : ticket ? [ticket] : [];
  if (!show || !event || passList.length === 0) return null;

  const getPassHolderType = ({
    is_membership_active,
    membership_expiry_date,
    event_start_date,
  }) => {
    if (!is_membership_active) return "Guest";

    if (!membership_expiry_date || !event_start_date) return "Guest";

    const membershipExpiry = new Date(membership_expiry_date);
    const eventStart = new Date(event_start_date);

    if (isNaN(membershipExpiry.getTime()) || isNaN(eventStart.getTime())) {
      return "Guest";
    }

    return membershipExpiry >= eventStart ? "GSTB Member" : "Guest";
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      {/* Header with close button */}
      <Modal.Header className="pb-0 p-0 d-flex justify-content-between event-passes-header-sec">
        <div className="pass-header px-3 py-3 position-relative px-sm-4 py-sm-3">
          <div>
            <h1 className="fw-semibold f-26 text-main mb-3">{event?.title}</h1>

            <div className="pass-meta d-flex flex-column">
              <span>
                <div className="me-2 f-18 ticket-header-icon">
                  <FaRegClock />
                </div>
                {`${formatEventDate(event)} • ${to12Hour(event?.start_time)}`}
              </span>
              <span>
                <div className="me-2 f-20 ticket-header-icon">
                  <HiOutlineLocationMarker />
                </div>{" "}
                {event?.venue}
              </span>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="calendar-close-btn ms-auto pass-close-icon position-absolute"
          onClick={onHide}
          aria-label="Close"
        >
          ✕
        </button>
      </Modal.Header>

      {/* Body */}

      <Modal.Body className="p-0 pass-card-body">
        {passList.map((ticket, index) => {
          const passType = getPassHolderType({
            is_membership_active: ticket?.is_membership_active,
            membership_expiry_date: ticket?.membership_expiry_date,
            event_start_date: formatEventDate(event),
          });

          return (
            <div key={ticket?._id || index} className="mb-4">
              <PassCard
                passHolder={ticket?.name}
                memberType={passType}
                qrCodeUrl={ticket?.qr_code_path}
                ticketId={ticket?.ticket_number}
                onDownload={() => onDownload?.(ticket?.pdf_path)}
              />
            </div>
          );
        })}
      </Modal.Body>
    </Modal>
  );
};

export default PassDetailsModal;
